<nb-card [nbSpinner]="loading" nbSpinnerStatus="primary">
    <nb-card-header class="d-flex justify-content-between align-items-center">
        <div>
            <span class="fw-bold">Matrice de Segmentation</span>
            <span *ngIf="snapshotDate" class="snapshot-label ms-2">
                Évolution depuis le {{snapshotDate}}
            </span>
        </div>
        <div class="d-flex align-items-center gap-2" *ngIf="axisTypes.length > 1">
            <label class="mb-0 small">Axe Y :</label>
            <nb-select [(selected)]="selectedAxis" (selectedChange)="onAxisChange()" size="small">
                <nb-option *ngFor="let axis of axisTypes" [value]="axis">{{getAxisLabel(axis)}}</nb-option>
            </nb-select>
        </div>
    </nb-card-header>

    <nb-card-body *ngIf="!loading && !error">
        <!-- Stats cards -->
        <div class="stats-row mb-3">
            <div class="stat-card">
                <div class="stat-value">{{formatCount(totalClients)}}</div>
                <div class="stat-label">Total base</div>
            </div>
            <div class="stat-card" *ngIf="hasCa">
                <div class="stat-value">{{formatCa(totalCa30j)}}</div>
                <div class="stat-label">CA 30 jours</div>
            </div>
            <div class="stat-card">
                <div class="stat-value">{{formatCount(actifsEmail)}}</div>
                <div class="stat-label">Emails actifs</div>
            </div>
        </div>

        <!-- Matrix grid -->
        <div class="matrix-wrapper">
            <table class="matrix-table">
                <thead>
                    <tr>
                        <th class="axis-corner">
                            <span class="corner-email">Email →</span>
                            <span class="corner-y">↓ {{getAxisLabel(selectedAxis)}}</span>
                            <span class="corner-diagonal"></span>
                        </th>
                        <th *ngFor="let col of colLabels" class="col-header"
                            [class.total-header]="col === 'Total'"
                            [nbTooltip]="getHeaderTooltip(col, 'email')"
                            [nbTooltipDisabled]="!getHeaderTooltip(col, 'email')">{{col}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of grid; let ri = index"
                        [class.total-row]="rowLabels[ri] === 'Total'">
                        <td class="row-header" [class.total-header]="rowLabels[ri] === 'Total'"
                            [nbTooltip]="getHeaderTooltip(rowLabels[ri], 'y')"
                            [nbTooltipDisabled]="!getHeaderTooltip(rowLabels[ri], 'y')">
                            {{rowLabels[ri]}}
                        </td>
                        <td *ngFor="let cell of row"
                            class="matrix-cell"
                            [class.selected]="selectedCell === cell"
                            [class.total-cell]="cell.isTotal"
                            [class.total-col]="cell.totalType === 'row' || cell.totalType === 'grand'"
                            [style.background-color]="cell.isTotal ? null : getCellBg(cell)"
                            [style.color]="cell.isTotal ? null : getCellTextColor(cell)"
                            (click)="selectCell(cell)">
                            <div class="cell-count">{{formatCount(cell.count)}}</div>
                            <div class="cell-delta" *ngIf="cell.deltaPct !== null && cell.totalType === 'col'"
                                 [class.positive]="cell.deltaPct >= 0"
                                 [class.negative]="cell.deltaPct < 0">
                                {{formatDelta(cell.deltaPct)}}
                            </div>
                            <div class="cell-ca" *ngIf="hasCa && cell.ca30j > 0">{{formatCa(cell.ca30j)}}</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Detail panel -->
        <div *ngIf="selectedCell" class="detail-panel mt-3">
            <div class="d-flex justify-content-between align-items-start">
                <div>
                    <h6 class="mb-1">{{selectedCell.rowLabel}} / {{selectedCell.colLabel}}</h6>
                    <div class="detail-stats">
                        <span class="fw-bold">{{formatCount(selectedCell.count)}} clients</span>
                        <span *ngIf="selectedCell.deltaPct !== null && selectedCell.totalType === 'col'" class="ms-2"
                              [class.text-success]="selectedCell.deltaPct >= 0"
                              [class.text-danger]="selectedCell.deltaPct < 0">
                            ({{formatDelta(selectedCell.deltaPct)}} vs J-30)
                        </span>
                        <span *ngIf="hasCa && selectedCell.ca30j > 0" class="ms-3 text-muted">
                            CA 30j: {{formatCa(selectedCell.ca30j)}}
                        </span>
                    </div>
                </div>
                <button *ngIf="selectedCell.totalType !== 'grand'"
                        nbButton size="small" status="primary" (click)="onAddToSegment()">
                    <nb-icon icon="plus-outline"></nb-icon> Filtrer le segment
                </button>
            </div>
        </div>
    </nb-card-body>

    <nb-card-body *ngIf="error">
        <div class="text-center text-muted p-3">{{error}}</div>
    </nb-card-body>
</nb-card>
